import { useDispatch } from 'react-redux';
import { ListItemIcon, MenuItem } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from 'react-i18next';
import apiSlice from '../features/api/rest/apiSlice';
import apiFoodFactsSlice from '../features/api/openFoodFacts/apiFoodFactsSlice';
import { useLogoutMutation } from '../features/api/rest/apiAuthSlice';
import { setAlertMessage } from '../features/layoutSlice';

function LogoutButton() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [logout] = useLogoutMutation();

  const toLogout = async () => {
    try {
      await logout();
      dispatch(apiSlice.util.resetApiState());
      dispatch(apiFoodFactsSlice.util.resetApiState());
      dispatch(setAlertMessage({ type: 'success', text: t('auth.messages.logout.success') }));
    } catch (error) {
      throw new Error(error);
    }
  };

  return (
    <MenuItem onClick={toLogout}>
      <ListItemIcon>
        <LogoutIcon fontSize="small" />
      </ListItemIcon>
      {t('common.actions.logout')}
    </MenuItem>
  );
}

export default LogoutButton;
